import React from 'react';
import { Link } from 'react-router-dom';

function formatDate(seconds) {
  const date = new Date(seconds * 1000);
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}/${m}/${d}`;
}

function BoardThreadCard({ thread, categoryId, subCategoryId, index }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: '12px',
        padding: '10px 12px',
        borderBottom: '1px solid var(--ch-border)',
      }}
    >
      <span
        style={{
          paddingTop: '2px',
          fontSize: '12px',
          fontWeight: 600,
          color: 'var(--ch-muted)',
          minWidth: '2.5rem',
          flexShrink: 0,
        }}
      >
        {index + 1}:
      </span>
      <div style={{ minWidth: 0, flex: 1 }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px' }}>
          <Link
            to={`/board/${categoryId}/${subCategoryId}/${thread.id}`}
            style={{ color: 'var(--ch-link)', fontSize: '14px', fontWeight: 500, wordBreak: 'break-all' }}
          >
            {thread.title}
          </Link>
          {thread.isQA && (
            <span
              style={{
                borderRadius: '9999px',
                padding: '1px 8px',
                fontSize: '10px',
                fontWeight: 600,
                backgroundColor: 'var(--ch-tag-qa-bg)',
                color: 'var(--ch-tag-qa-text)',
              }}
            >
              教えて！
            </span>
          )}
          {thread.isResolved && (
            <span
              style={{
                borderRadius: '9999px',
                padding: '1px 8px',
                fontSize: '10px',
                fontWeight: 600,
                backgroundColor: 'var(--ch-tag-resolved-bg)',
                color: 'var(--ch-tag-resolved-text)',
              }}
            >
              解決済み
            </span>
          )}
        </div>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: '12px',
            marginTop: '4px',
            fontSize: '12px',
            color: 'var(--ch-muted)',
          }}
        >
          <span>返信 {thread.replyCount}</span>
          {thread.createdAt?.seconds && <span>{formatDate(thread.createdAt.seconds)}</span>}
        </div>
      </div>
    </div>
  );
}

export default BoardThreadCard;
